class BeerPackBuilder extends HTMLElement {

  constructor() {
    super();

    this.selections = {};
    this.maxItems = window.packMaxItems || 3;
    this.precioBase = window.packPrecioBase || 0;
  }

  connectedCallback() {
    // this.render();
    this.loadExistingPack();
  }

  async loadExistingPack() {
    const params = new URLSearchParams(window.location.search);
    const editKey = params.get('edit');
    if (!editKey) {
      this.render();
      return;
    }
    const response = await fetch('/cart.js');
    const cart = await response.json();
    const item = cart.items.find(
      item => item.key === editKey
    );
    if (!item) {
      this.render();
      return;
    }
    const selection = item.properties?._beer_pack_selection;
    if (selection) {
      selection.split(' · ')
        .forEach(entry => {
          const parts = entry.trim().split(' ');
          const qty = parseInt(parts[0]);
          const title =
            parts.slice(1).join(' ');
          const beer = window.beers.find(
            b => b.title === title
          );
          if (beer) {
            this.selections[beer.id] = qty;
          }
        });
    }
    this.editingKey = editKey;
    this.editingQuantity = item.quantity || 1;
    this.render();
  }

  getTotal() {
    return Object.values(this.selections)
      .reduce((sum, qty) => sum + qty, 0);
  }

  increase(id) {
    const total = this.getTotal();
    if (total >= this.maxItems) {
      return;
    }
    this.selections[id] = (this.selections[id] || 0) + 1;
    this.render();
  }

  decrease(id) {
    if (!this.selections[id]) {
      return;
    }
    this.selections[id]--;
    if (this.selections[id] <= 0) {
      delete this.selections[id];
    }
    this.render();
  }

  async addToCart() {

    const summary = window.beers
      .filter(beer => this.selections[beer.id] > 0)
      .map(beer => {
        const qty = this.selections[beer.id];
        return `${qty} ${beer.title}`;
      })
      .join(' · ');

    if (this.editingKey) {
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          id: this.editingKey,
          quantity: 0
        })
      });
    }

    let aTypeCount = 0;
    window.beers.forEach(beer => {
      const qty = this.selections[beer.id] || 0;
      const priceType = (beer.priceType || '').toUpperCase();
      if (priceType === 'A') {
        aTypeCount += qty;
      }
    });
    const variantKey = `A${aTypeCount}`;
    const variantId =  window.packVariants[variantKey];

    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        items: [
          {
            id: variantId,
            quantity: this.editingQuantity || 1,
            properties: {
              '_beer_pack_selection': summary,
              '_pack_data': JSON.stringify(this.selections),
              'Botellas': summary
            }
          }
        ]
      })
    });

    window.location.href = '/cart';
  }


  render() {

    const total = this.getTotal();

    const remaining = this.maxItems - total;
    let progressMessage = '';
    if (remaining > 0) {
      progressMessage = 
        `Te falta${remaining > 1 ? 'n' : ''} ${remaining} botella${remaining > 1 ? 's' : ''} para completar tu pack`;
    } else {
      progressMessage = '¡Tu pack está listo!';
    }

    const subtotal = parseFloat(this.precioBase) + window.beers.reduce((sum, beer) => {
        const qty = this.selections[beer.id] || 0;
        return sum + (qty * parseFloat(beer.price));
      }, 0);

    const selectedBadges = window.beers
      .filter(beer => this.selections[beer.id] > 0)
      .map(beer => {
        const qty = this.selections[beer.id];
        return `<div class="beer-badge">${qty} ${beer.title}</div>`;
      })
      .join(' ');
      
    const cards = window.beers.map(beer => {
      const qty = this.selections[beer.id] || 0;
      return `
        <div class="beer-card ${qty > 0 ? 'selected' : ''}">
          <img
            src="${beer.image}"
            alt="${beer.title}"
            class="beer-image"
          >
          <h3>${beer.title}</h3>
          <p class="beer-price">
            $ ${beer.price}
          </p>
          <div class="qty-controls">
            <button
              class="qty-btn"
              data-action="minus"
              data-id="${beer.id}"
            >
              −
            </button>
            <span class="qty-value">
              ${qty}
            </span>
            <button
              class="qty-btn"
              data-action="plus"
              data-id="${beer.id}"
              ${total >= this.maxItems ? 'disabled' : ''}
            >
              +
            </button>
          </div>
        </div>
      `;
    }).join('');

    this.innerHTML = `

      <div class="beer-builder">
        <div class="beer-header">
          ${this.editingKey ? 'Modificando Pack' : 'Nuevo Pack' }
        </div>
        <div class="beer-pack">
          ${cards}
        </div>

        <div class="beer-footer">
          <div class="beer-footer-left">
          <div class="beer-footer-message">
            ${progressMessage}
          </div>
          <div class="beer-footer-badges">
              ${selectedBadges}
            </div>
            <div class="beer-subtotal">
              Total:
              <strong>$ ${subtotal.toFixed(0)}</strong>
            </div>
          </div>

          <button
            class="add-cart-btn"
            ${total !== this.maxItems ? 'disabled' : ''}
          >
          ${this.editingKey ? 'Actualizar pack' : 'Agregar al carrito' }
          </button>

        </div>


      </div>

    `;

    this.bindEvents();
  }

  bindEvents() {

    this.querySelectorAll('[data-action="plus"]')
      .forEach(btn => {

        btn.addEventListener('click', () => {
          this.increase(btn.dataset.id);
        });

      });

    this.querySelectorAll('[data-action="minus"]')
      .forEach(btn => {

        btn.addEventListener('click', () => {
          this.decrease(btn.dataset.id);
        });

      });

    const addBtn = this.querySelector('.add-cart-btn');
    if (addBtn) {
      addBtn.addEventListener('click', () => {
        if (this.getTotal() === this.maxItems) {
          this.addToCart();
        }
      });

    }
  }
}

customElements.define(
  'beer-pack-builder',
  BeerPackBuilder
);